import React from "react";

const Feedback = ({ name, position, photo, feedback, className }) => {
  return (
    <div
      className={`space-y-8 flex flex-col items-center justify-center w-full lg:max-w-5xl mx-auto ${className}`}
    >
      <p className="text-base lg:text-xl text-center leading-loose header lg:max-w-4xl mx-auto">
        {feedback}
      </p>
      <div className="flex flex-col lg:flex-row items-center gap-6">
        <div
          className="w-16 h-16 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center
            text-base lg:text-2xl"
        >
          {photo ? (
            <img
              src={photo}
              alt="user"
              className="object-cover min-h-full min-w-full"
              width="64"
              height="64"
            />
          ) : (
            name.charAt(0)
          )}
        </div>
        <div className="space-y-1 flex flex-col items-center lg:items-start">
          <p className="text-base lg:text-2xl font-neue-bold text-center">
            {name}
          </p>
          <p className="text-sm lg:text-lg text-gray-middle font-neue-medium text-center">
            {position}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
